import { render } from "./EntriesPerPage.vue?vue&type=template&id=60c60d6e"
import script from "./EntriesPerPage.vue?vue&type=script&lang=js"
export * from "./EntriesPerPage.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/dyo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__